// Target of the password-reset e-mail: /reset-password?token=...
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { confirmPasswordReset } from "@/lib/auth";

export const Route = createFileRoute("/reset-password")({
  component: ResetPassword,
});

function ResetPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError("Şifreler eşleşmiyor");
      return;
    }
    setBusy(true);
    try {
      await confirmPasswordReset(token, password);
      await navigate({ to: "/", replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Şifre güncellenemedi");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-screen grid place-items-center p-4 text-white"
      style={{
        background: "linear-gradient(135deg,#0a0a1a 0%,#141432 45%,#1e1e5a 80%,#4f46e5 100%)",
      }}
    >
      <div className="nova-glass w-full max-w-md rounded-2xl p-8">
        <div className="font-display text-2xl font-bold tracking-tight">Yeni şifre</div>
        <div className="mt-1 text-xs text-white/60">
          Orb Tab hesabınız için yeni bir şifre belirleyin.
        </div>

        {!token ? (
          <p className="mt-6 text-sm text-red-200">
            Bağlantıda sıfırlama anahtarı yok. E-postadaki bağlantıyı tekrar açın.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input
              type="password"
              required
              minLength={6}
              placeholder="Yeni şifre (min 6 karakter)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-white/20 bg-white/10 px-4 py-3 placeholder:text-white/40 focus:border-white/40 focus:outline-none"
            />
            <input
              type="password"
              required
              minLength={6}
              placeholder="Yeni şifre (tekrar)"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full rounded-lg border border-white/20 bg-white/10 px-4 py-3 placeholder:text-white/40 focus:border-white/40 focus:outline-none"
            />
            <button
              type="submit"
              disabled={busy}
              className="nova-btn-primary w-full rounded-lg py-3 font-semibold text-white transition disabled:opacity-50"
            >
              {busy ? "..." : "Şifreyi güncelle"}
            </button>
          </form>
        )}

        {error && (
          <div className="mt-3 rounded-lg bg-red-500/20 p-3 text-sm text-red-100">{error}</div>
        )}

        <a
          href="/"
          className="mt-4 block text-center text-xs text-white/60 transition hover:text-white"
        >
          Giriş ekranına dön
        </a>
      </div>
    </div>
  );
}
